module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ChaSearchAll',
        query: {}
      }),
      expression: "{name:'ChaSearchAll',query:{}}"
    }],
    staticClass: "search"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icon_search.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_vm._v("搜索你想找的信息")])]), _vm._v(" "), (_vm.picList.length > 0) ? _c('div', {
    staticClass: "swipe-box"
  }, [_c('van-swipe', {
    attrs: {
      "indicator-color": "#F7B500",
      "duration": 300
    }
  }, _vm._l((_vm.picList), function(item, index) {
    return _c('van-swipe-item', {
      key: index
    }, [_c('img', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsDetail',
          query: {
            id: item.id
          }
        }),
        expression: "{name:'NewsDetail',query:{id:item.id }}"
      }],
      attrs: {
        "src": item.pic_url,
        "alt": ""
      }
    })])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('van-tabs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cate_list.length > 1),
      expression: "cate_list.length>1"
    }],
    staticClass: "active-tab",
    attrs: {
      "animated": "",
      "sticky": ""
    },
    on: {
      "change": _vm.cateChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, _vm._l((_vm.cate_list), function(item, index) {
    return _c('van-tab', {
      key: index,
      scopedSlots: _vm._u([{
        key: "title",
        fn: function() {
          return [(item.num > 0) ? _c('span', {
            staticClass: "active-tab-num"
          }, [_vm._v(_vm._s(item.num))]) : _vm._e(), _vm._v("\n              " + _vm._s(item.name) + "\n            ")]
        },
        proxy: true
      }], null, true)
    })
  }), 1), _vm._v(" "), _vm._l((_vm.list), function(row, i) {
    return _c('div', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.goDetail(row)
        }
      }
    }, [(row.pics.length == 0) ? _c('NewsItem1', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (row.pics.length == 1) ? _c('NewsItem2', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (false) ? _c('NewsItem3') : _vm._e(), _vm._v(" "), (row.pics.length > 1) ? _c('NewsItem4', {
      attrs: {
        "row": row
      }
    }) : _vm._e()], 1)
  })], 2)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d861cfd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/news/NewsList.vue
// module id = 2303
// module chunks = 0